import {
  Button,
  LoadingIndicator,
  SlideoutMenu,
} from "@light-technology/components";
import { Check, Link01 } from "@untitledui/icons";
import type {
  AppConfigurationResponse,
  PlanResponse,
} from "../../state/api.types";
import { useFormatPlanName } from "../../utilities/useFormatPlanName";
import { TABS } from "./common";

type HeaderProps = {
  close: () => void;
  plan?: PlanResponse;
  configuration?: AppConfigurationResponse | null;
};

export const Header = ({ close, plan, configuration }: HeaderProps) => {
  const formatPlanName = useFormatPlanName();
  return (
    <SlideoutMenu.Header onClose={close} tabs={TABS}>
      {!plan || !configuration ? (
        <LoadingIndicator type="brand-spinner" />
      ) : (
        <div className="flex flex-col">
          <div className="flex flex-row items-center gap-2">
            <div className="text-display-xs font-semibold">
              {formatPlanName(plan.name)}
            </div>
            <Button
              size="sm"
              color="tertiary"
              tooltip="Copy shareable link to plan"
              tooltipOnClick="Link copied to clipboard"
              iconLeading={Link01}
              iconLeadingOnClick={Check}
              onClick={() => {
                navigator.clipboard.writeText(window.location.href);
              }}
            />
          </div>
          <div className="font-mono text-sm text-tertiary">{plan.uuid}</div>
        </div>
      )}
    </SlideoutMenu.Header>
  );
};
